export class PasswordResetModel {

  /**
   * Constructor
   *
   * @param hash
   * @param token
   * @param email
   * @param password
   * @param passwordConfirmation
   */
  public constructor(
    public hash: string,
    public token: string,
    public email: string = null,
    public password: string = null,
    public passwordConfirmation: string = null,
  ) { }
}
